module.exports = __webpack_public_path__ + "static/hedrian-195d4cdaada8b4eb2f54749da9af24ad.svg";